import React, { useState, useContext } from "react";
import { Form, Select } from "antd";
import { getFormItemLabel, getFormItemVaidation } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import RestrictedContext from "../util/RestrictedContext";
import useDeepCompareEffect from "use-deep-compare-effect";
import { getSystemTableData } from "../../api/server";
import { AutoComplete } from "antd";

const { Option } = Select;

const FreeTextAndSelectItem = (props) => {
  const { name, required, category, disabled, params, identfierId, ...rest } =
    props;

  const intl = useIntl();
  const [data, setData] = useState([]);
  const restricted = useContext(RestrictedContext);

  useDeepCompareEffect(() => {
    getSystemTableData({ ...params }).then(({ error, data }) => {
      if (data) {
        setData(data.items);
      }
    });
  }, [params, {}]);

  const label = getFormItemLabel(intl, category, name, null);
  const arr = [];
  if (required) {
    arr.push("required");
  }
  const rules = getFormItemVaidation(intl, label, arr);
  const identfier = identfierId ? identfierId : "name";

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <AutoComplete
        {...rest}
        allowClear
        disabled={disabled || !restricted["hasWritePermission"]}
        filterOption={(inputValue, option) => {
          return option.value.indexOf(inputValue) !== -1;
        }}
      >
        {data.map((option) => (
          <Option key={option[identfier]} value={option[identfier]}>
            {option.name}
          </Option>
        ))}
      </AutoComplete>
    </Form.Item>
  );
};

FreeTextAndSelectItem.propTypes = {
  name: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  category: PropTypes.string,
  params: PropTypes.object,
  onChange: PropTypes.func,
};

export default FreeTextAndSelectItem;
